import { ToolbarControl } from '../Toolbar/controls';

export const DEFAULT_CONTROLS: ToolbarControl[][] = [
  ['bold', 'italic', 'underline', 'strike', 'clean'],
  ['h1', 'h2', 'h3', 'h4'],
  ['unorderedList', 'orderedList'],
  ['link', 'image', 'video', 'blockquote', 'codeBlock'],
  ['alignLeft', 'alignCenter', 'alignRight'],
  ['sup', 'sub'],
];
